// Code reused from the Header & Footer component
import { useCallback } from 'react';

const getNavElement = () => {
  if (typeof document === 'undefined') return null;
  return document.querySelector('#header-nav-container');
};

const isScrollbarVisible = () => {
  return window.innerWidth > document.documentElement.clientWidth;
};

const getScrollbarSize = () => {
  return Math.abs(window.innerWidth - document.documentElement.clientWidth);
};

export const useScrollLock = () => {
  const headerNav = getNavElement();

  const lockScroll = useCallback(() => {
    if (typeof document !== 'undefined') {
      if (isScrollbarVisible()) {
        document.body.style.paddingRight = `${getScrollbarSize()}px`;
        if (headerNav) {
          if ('positionBottom' in headerNav.dataset) {
            headerNav.style.paddingRight = `${getScrollbarSize()}px`;
          }
        }
      }
      document.body.style.overflow = 'hidden';
    }
  }, []);

  const unlockScroll = useCallback(() => {
    if (typeof document !== 'undefined') {
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');
      if (headerNav) {
        headerNav.style.removeProperty('padding-right');
      }
    }
  }, []);

  return { lockScroll, unlockScroll };
};
